module.exports = __webpack_public_path__ + "media/product/cat-02-7d03ffb3.png";